module.exports = __webpack_public_path__ + "static/27-7a6232ca85c82c22638d2660898a9c3b.png";